import React from 'react';
import Contact from '../../components/contact/contact';

function contactpage() {
  return (
    <>
        <Contact />
    </>
  )
}

export default contactpage